/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_SkippedInputs */

const cs_pm_skipped = /** @type {(inputs: Pm_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočeno`)
};

const en_pm_skipped = /** @type {(inputs: Pm_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped`)
};

/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Pm_SkippedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_skipped = /** @type {((inputs?: Pm_SkippedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_SkippedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_skipped(inputs)
	return cs_pm_skipped(inputs)
});